import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { ApiCredential } from '../../types/api-credentials.type';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';

@Injectable({ providedIn: 'root' })
export class ApiCredentialsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/api-credentials`;
  }

  async getApiCredentials(): Promise<ApiCredential[]> {
    const credentials = await this.get<ApiCredential[]>('');
    ApiConversionHelper.convertDates(credentials, ['validFrom', 'validTo', 'lastConnected']);
    return credentials;
  }

  // Create a new API credential
  async createApiCredential(apiCredential: ApiCredential): Promise<void> {
    ApiConversionHelper.convertDateTimesForApi(apiCredential, ['validFrom', 'validTo']);
    await this.post<ApiCredential>('', apiCredential);
  }

  // Update an existing API credential
  async updateApiCredential(apiCredential: ApiCredential): Promise<void> {
    ApiConversionHelper.convertDateTimesForApi(apiCredential, ['validFrom', 'validTo']);
    return await this.put<ApiCredential>('', apiCredential);
  }

  // Delete an API credential by ID
  async deleteAPICredential(id: string): Promise<void> {
    return await this.delete(`${id}`);
  }
}
